<template>
  <div>
    <Grid
      :service="service"
      route_name="payment_splits"
      route_grid_path="/grid"
      order_column="created_at"
      direction="desc"
      hide_actions="true"
      :show-export="true"
      :export-types="['csv', 'xls']"
      export-filename="hubee_payment_splits"
      :fetch-on-mounted="false"
      hide_searchbar="true"
      ref="grid"
    >
      <template v-slot:filterZone>
        <FinancialPeriodFilter v-model="filters" @change="handleFilterChange" />
      </template>

      <template v-slot:gridThead>
        <vs-th key="id" sort-key="id">ID Split</vs-th>
        <vs-th key="payment_id" sort-key="payment_id">ID Pagamento</vs-th>
        <vs-th key="split_to" sort-key="split_to">Tipo</vs-th>
        <vs-th key="recipient_name">Recebedor</vs-th>
        <vs-th key="amount_total" sort-key="amount_total">Valor Total</vs-th>
        <vs-th key="value" sort-key="value">Valor</vs-th>

        <vs-th key="created_at" sort-key="created_at">Data</vs-th>
      </template>

      <template v-slot:gridData="props">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in props.data">
          <vs-td width="5%" key="id">
            <div>{{ tr.id }}</div>
          </vs-td>
          <vs-td width="10%" key="payment_id">
            <div>{{ tr.payment_id }}</div>
          </vs-td>
          <vs-td width="10%" key="split_to">
            <vs-chip :color="getSplitToColor(tr.split_to)" class="text-base">
              {{ getSplitToLabel(tr.split_to) }}
            </vs-chip>
          </vs-td>
          <vs-td width="30%" key="recipient_name">
            <div>
              {{ tr.recipient_name }}
              <vs-chip v-if="tr.is_platform_fee" color="warning" class="text-sm ml-1">
                Taxa da plataforma{{ tr.applied_fee_percent ? ` (${tr.applied_fee_percent}%)` : '' }}
              </vs-chip>
            </div>
          </vs-td>
          <vs-td width="10%" key="amount_total">
            <div>{{ formatCurrency(tr.amount_total) }}</div>
          </vs-td>
          <vs-td width="15%" key="value">
            <span class="font-semibold">{{ formatCurrency(tr.value) }}</span>
          </vs-td>
          <vs-td width="20%" key="created_at">
            <div>{{ $utils.format.date(tr.created_at) }}</div>
          </vs-td>
        </vs-tr>
      </template>
    </Grid>
  </div>
</template>

<script>
import Grid from '@/components/Grid.vue'
import FinancialPeriodFilter from '@/components/filters/FinancialPeriodFilter.vue'
import PaymentSplitService from '@/services/api/PaymentSplitService'
import { currencyFormatter } from '@/util/Util'

export default {
  components: {
    Grid,
    FinancialPeriodFilter
  },
  data() {
    return {
      service: null,
      filters: {
        institution_id: null,
        start_date: null,
        end_date: null
      }
    }
  },
  methods: {
    formatCurrency(value) {
      return currencyFormatter(value)
    },
    getSplitToColor(splitTo) {
      return splitTo === 'LE' ? 'primary' : 'success'
    },
    getSplitToLabel(splitTo) {
      return splitTo === 'LE' ? 'Pessoa Jurídica' : 'Pessoa Física'
    },
    handleFilterChange(filters) {
      this.filters = filters
      this.updateFilters()
    },
    updateFilters() {
      const customFilters = {}

      if (this.filters.institution_id) {
        customFilters.institution_id = this.filters.institution_id
      }

      if (this.filters.start_date) {
        customFilters.start_date = this.filters.start_date
      }

      if (this.filters.end_date) {
        customFilters.end_date = this.filters.end_date
      }

      // Limpar todos os custom_filters primeiro
      this.$refs.grid.custom_filters = []

      // Preencher apenas os filtros que têm valores
      if (Object.keys(customFilters).length > 0) {
        this.$refs.grid.fillCustomFilters(
          Object.keys(customFilters).map(key => ({
            key,
            value: customFilters[key]
          }))
        )
      }

      this.$refs.grid.fetchGridData(true)
    }
  },
  beforeMount() {
    this.service = PaymentSplitService.build(this.$vs)
  }
}
</script>

<style scoped>
.vs-select {
  min-width: 200px;
}
</style>
